import * as Yup from 'yup'; 
import { FieldTypes, IFields, InputModes } from '../../models/form/IFieldsDefinition'
import { isDateValid, isNotEarlierDate, isNotFutureDate } from '../../components/form/Validations/DateValidation'
import { firstLetterCapitalized, onlyNumbers } from '../../components/form/Helpers/Parsers'
import { IncomeTypeEnum } from './IncomeTypes'
import { hasNIPCorrectFormat } from '../../components/form/Validations/NIPValidation'
import { IDropdownOption, InputBooleanOptions } from '../../components/form/Fields/InputDropdown/InputDropdownProps'
import { FormValidationObject } from '../../models/form/IFormDefinition'
import { IFieldsDataStateFieldValue } from '../../store/types'

export const incomeReceivedDayList: IDropdownOption[] = Array.from({ length: 31 }, (_, i) => {
   return {
      value:(i + 1).toString(),
      label: (i + 1).toString(),
   }
}) //Automatycznie generowana tablica z wartościami od 1 do 31



const socialBenefitsReceivedNumber = [
   {value: '0', label: 'Brak świadczenia'},
   {value: '1', label: '1'},
   {value: '2', label: '2'},
   {value: '3', label: '3'},
   {value: '4', label: '4'},
   {value: '5', label: '5'},
   {value: '6', label: '6'},
   {value: '7', label: '7'},
]

export enum IncomeBasicFieldsNames {
   MainIncomeType =  'MainIncomeType',
   SocialBenefitsNumber =  'SocialBenefitsNumber',
   CostOfLiving = 'CostOfLiving',
}

export enum IncomeAdditionalFieldsNames {
   WorkplaceNIP =  'WorkplaceNIP',
   WorkplaceName =  'WorkplaceName',
   EmploymentFromDate =  'EmploymentFromDate',
   BenefitRecivedFromDate =  'BenefitRecivedFromDate',
   SoleProprietorshipFromDate =  'SoleProprietorshipFromDate',
   FarmRunningFromDate =  'FarmRunningFromDate',
   RentalFromDate =  'RentalFromDate',
   IsEmploymentIndefinitely =  'IsEmploymentIndefinitely',
   IsBenefitIndefinitely =  'IsBenefitIndefinitely',
   EmploymentToDate =  'EmploymentToDate',
   RentalToDate =  'RentalToDate',
   BenefitRecivedToDate =  'BenefitRecivedToDate',
   IncomePerMonthNetto =  'IncomePerMonthNetto',
   IncomeReceivedDay =  'IncomeReceivedDay',
   NIP =  'NIP',
   CompanyName =  'CompanyName',
   HasUnionGrants =  'HasUnionGrants',
   UnionGrantAmount =  'UnionGrantAmount',
}


const EmploymentContractFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.WorkplaceNIP,
   IncomeAdditionalFieldsNames.WorkplaceName,
   IncomeAdditionalFieldsNames.EmploymentFromDate,
   IncomeAdditionalFieldsNames.IsEmploymentIndefinitely,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const RetirementFields: readonly IncomeAdditionalFieldsNames[] =  [
   IncomeAdditionalFieldsNames.BenefitRecivedFromDate, 
   IncomeAdditionalFieldsNames.IncomePerMonthNetto, 
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const ContractFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.WorkplaceNIP,
   IncomeAdditionalFieldsNames.WorkplaceName,
   IncomeAdditionalFieldsNames.EmploymentFromDate,
   IncomeAdditionalFieldsNames.IsEmploymentIndefinitely,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const PensionFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.BenefitRecivedFromDate,
   IncomeAdditionalFieldsNames.IsBenefitIndefinitely,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const SoleProprietorshipFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.SoleProprietorshipFromDate,
   IncomeAdditionalFieldsNames.NIP,
   IncomeAdditionalFieldsNames.CompanyName,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const CommissionAgreementFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.WorkplaceNIP,
   IncomeAdditionalFieldsNames.WorkplaceName,
   IncomeAdditionalFieldsNames.EmploymentFromDate,
   IncomeAdditionalFieldsNames.IsEmploymentIndefinitely,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const FarmFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.FarmRunningFromDate,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.HasUnionGrants,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const

const RentalFields: readonly IncomeAdditionalFieldsNames[] = [
   IncomeAdditionalFieldsNames.RentalFromDate,
   IncomeAdditionalFieldsNames.RentalToDate,
   IncomeAdditionalFieldsNames.IncomePerMonthNetto,
   IncomeAdditionalFieldsNames.IncomeReceivedDay,
] as const


export type TIncomeFieldsValues = {[K in IncomeAdditionalFieldsNames]?: IFieldsDataStateFieldValue}

export const incomeType = [
   {  value: IncomeTypeEnum.EmploymentContract,   fields: EmploymentContractFields,     label: 'Umowa o pracę',           },
   {  value: IncomeTypeEnum.Retirement,           fields: RetirementFields,             label: 'Emerytura',               },
   {  value: IncomeTypeEnum.Contract,             fields: ContractFields,               label: 'Kontrakt',                },
   {  value: IncomeTypeEnum.Pension,              fields: PensionFields,                label: 'Renta',                   },
   {  value: IncomeTypeEnum.SoleProprietorship,   fields: SoleProprietorshipFields,     label: 'Działalność gospodarcza', },
   {  value: IncomeTypeEnum.CommissionAgreement,  fields: CommissionAgreementFields,    label: 'Umowa zlecenie',          },
   {  value: IncomeTypeEnum.Farmer,               fields: FarmFields,                   label: 'Działalność rolnicza',    },
   {  value: IncomeTypeEnum.Rental,               fields: RentalFields,                 label: 'Najem',                   },
]





export const incomeBaseInfoFieldsDefinition: IFields = {
   [IncomeBasicFieldsNames.MainIncomeType]: {
      order: 0,
      name: IncomeBasicFieldsNames.MainIncomeType,
      type: FieldTypes.dropdownChangeIncomeTypeField,
      label: "Główne źródło dochodu",
      options: incomeType,
      editable: true,
   },
   [IncomeBasicFieldsNames.CostOfLiving]: {
      order: 95,
      name: IncomeBasicFieldsNames.CostOfLiving,
      type:  FieldTypes.number,
      label: "Miesięczne wydatki na gosp. domowe",
      editable: true,
      maxLength: 4,
   },
   [IncomeBasicFieldsNames.SocialBenefitsNumber]: {
      order: 100,
      name: IncomeBasicFieldsNames.SocialBenefitsNumber,
      type:  FieldTypes.dropdown,
      label: "Ilość świadczeń 800+",
      options: socialBenefitsReceivedNumber,
      editable: true,
   },
}





export const incomeAdditionalInfoFieldsDefinition: IFields = {
   [IncomeAdditionalFieldsNames.WorkplaceName]: {
      order: 5,
      name: IncomeAdditionalFieldsNames.WorkplaceName,
      label: "Nazwa Pracodawcy",
      type: FieldTypes.string,
      maxLength: 50,
      editable: true,
      isAdditionalField: true,
      parser: firstLetterCapitalized,
   },
   [IncomeAdditionalFieldsNames.WorkplaceNIP]: {
      order: 6,
      name: IncomeAdditionalFieldsNames.WorkplaceNIP,
      label: "NIP Pracodawcy",
      type: FieldTypes.string,
      editable: true,
      maxLength: 10,
      isAdditionalField: true,
      parser: onlyNumbers,
      inputMode: InputModes.numeric,
   },
   [IncomeAdditionalFieldsNames.EmploymentFromDate]: {
      order: 7,
      name: IncomeAdditionalFieldsNames.EmploymentFromDate,
      label: "Data zatrudnienia od",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.BenefitRecivedFromDate]: {
      order: 5,
      name: IncomeAdditionalFieldsNames.BenefitRecivedFromDate,
      label: "Od kiedy uzyskiwane jest świadczenie?",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.SoleProprietorshipFromDate]: {
      order: 7,
      name: IncomeAdditionalFieldsNames.SoleProprietorshipFromDate,
      label: "Data rozpoczęcia działalności",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.FarmRunningFromDate]: {
      order: 5,
      name: IncomeAdditionalFieldsNames.FarmRunningFromDate,
      label: "Data rozpoczęcia działalności rolniczej",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.RentalFromDate]: {
      order: 5,
      name: IncomeAdditionalFieldsNames.RentalFromDate,
      label: "Data rozpoczęcia najmu lokalu",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.IsEmploymentIndefinitely]: {
      order: 8,
      name: IncomeAdditionalFieldsNames.IsEmploymentIndefinitely,
      label: "Czy jesteś zatrudniony bezterminowo?",
      type: FieldTypes.boolean,
      options: [
         { value: false, label: InputBooleanOptions.agree }, // Pytanie tak skonstruowane, że wartość odpowiedzi negatywnej musi być wartością "true", a pozytywnej "false"
         { value: true, label: InputBooleanOptions.disagree }
      ],
      editable: true,
      isAdditionalField: true,
      associatedFieldName: IncomeAdditionalFieldsNames.EmploymentToDate,
   },
   [IncomeAdditionalFieldsNames.IsBenefitIndefinitely]: {
      order: 6,
      name: IncomeAdditionalFieldsNames.IsBenefitIndefinitely,
      label: "Czy świadczenie jest bezterminowe?",
      type: FieldTypes.boolean,
      options: [
         { value: false, label: InputBooleanOptions.agree }, // Pytanie tak skonstruowane, że wartość odpowiedzi negatywnej musi być wartością "true", a pozytywnej "false"
         { value: true, label: InputBooleanOptions.disagree }
      ],
      editable: true,
      isAdditionalField: true,
      associatedFieldName: IncomeAdditionalFieldsNames.BenefitRecivedToDate,
   },
   [IncomeAdditionalFieldsNames.EmploymentToDate]: {
      order: 9,
      name: IncomeAdditionalFieldsNames.EmploymentToDate,
      label: "Data zatrudnienia do", 
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.RentalToDate]: {
      order: 10,
      name: IncomeAdditionalFieldsNames.RentalToDate,
      label: "Data zakończenia najmu lokalu", 
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.BenefitRecivedToDate]: {
      order: 7,
      name: IncomeAdditionalFieldsNames.BenefitRecivedToDate,
      label: "Do kiedy przyznane jest świadczenie?",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.IncomePerMonthNetto]: {
      order: 10,
      name: IncomeAdditionalFieldsNames.IncomePerMonthNetto,
      label: "Dochód miesięczny netto",
      type: FieldTypes.number,
      maxLength: 10,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.IncomeReceivedDay]: {
      order: 25,
      name: IncomeAdditionalFieldsNames.IncomeReceivedDay,
      label: "Dzień wpływu wynagrodzenia",
      type: FieldTypes.dropdown, 
      options: incomeReceivedDayList,
      editable: true,
      isAdditionalField: true,
   },
   [IncomeAdditionalFieldsNames.CompanyName]: {
      order: 5,
      name: IncomeAdditionalFieldsNames.CompanyName,
      label: "Nazwa firmy",
      type: FieldTypes.string,
      maxLength: 50,
      editable: true,
      isAdditionalField: true,
      parser: firstLetterCapitalized,
   },
   [IncomeAdditionalFieldsNames.NIP]: {
      order: 6,
      name: IncomeAdditionalFieldsNames.NIP,
      label: "NIP firmy",
      type: FieldTypes.string,
      editable: true,
      maxLength: 10,
      isAdditionalField: true,
      parser: onlyNumbers,
      inputMode: InputModes.numeric,
   },
   [IncomeAdditionalFieldsNames.HasUnionGrants]: {
      order: 15,
      name: IncomeAdditionalFieldsNames.HasUnionGrants,
      label: "Czy posiadasz dochód z dotacji uninej?",
      type: FieldTypes.boolean,
      options: [
         { value: true, label: InputBooleanOptions.agree },
         { value: false, label: InputBooleanOptions.disagree }
      ],
      editable: true,
      isAdditionalField: true,
      associatedFieldName: IncomeAdditionalFieldsNames.UnionGrantAmount,
   },
   [IncomeAdditionalFieldsNames.UnionGrantAmount]: {
      order: 20,
      name:IncomeAdditionalFieldsNames.UnionGrantAmount,
      label: "Łączna kwota dotacji",
      type: FieldTypes.number,
      maxLength: 10,
      editable: true,
      isAdditionalField: true,
   },
}

export const incomeInfoFieldValidations: FormValidationObject<typeof IncomeBasicFieldsNames> & FormValidationObject<typeof IncomeAdditionalFieldsNames> = {
   [IncomeBasicFieldsNames.MainIncomeType]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeBasicFieldsNames.CostOfLiving]: Yup.string().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
   [IncomeBasicFieldsNames.SocialBenefitsNumber]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,


   [IncomeAdditionalFieldsNames.WorkplaceName]: Yup.string().trim().required("Niepoprawna wartość").min(2, "Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.WorkplaceNIP]: Yup.string().required("Niepoprawna wartość").test(hasNIPCorrectFormat) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.EmploymentFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.BenefitRecivedFromDate]:  Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.SoleProprietorshipFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.FarmRunningFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.RentalFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.IsEmploymentIndefinitely]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.IsBenefitIndefinitely]:  Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.EmploymentToDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.RentalToDate]:  Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.BenefitRecivedToDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.IncomePerMonthNetto]: Yup.string().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.IncomeReceivedDay]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.CompanyName]: Yup.string().trim().required("Niepoprawna wartość").min(2, "Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.NIP]:  Yup.string().required("Niepoprawna wartość").test(hasNIPCorrectFormat) as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.HasUnionGrants]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [IncomeAdditionalFieldsNames.UnionGrantAmount]: Yup.string().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
}